export default __webpack_public_path__ + "static/media/copy.69b772db.svg";